import React, { useEffect, useState, useContext } from 'react';

function SiteManagement(props) {
    return (
        <div>SiteManagement</div>
    )
}

export default SiteManagement;